import { getDataBase } from '../db';

export default class MediaConsumoDAL {
    constructor() {
      this.MenorIgualQue = "MEI";
      this.MayorQue = "MAQ";
    }
  
    //RESUELTO
    async SeValida(tcMedia, Consumo, lnValorRef, DataBaseAlias) {
       //consutla indexDB
      
        // const response = await fetch(`/api/${DataBaseAlias}/media-consumo`);
        // const loMediaConsumo = await response.json();
        //RESUELTO
        const loMediaConsumo = await this.getMediaConsumo();
        
        // const loMediaConsumo = [];
        // loMediaConsumo.push({
        //   Estado: 1,
        //   ConsumoReferencia: 10,
        //   Consumo_Net: "MEI",
        //   MediaReferencia: 15,
        //   Media_Net: "MEI",
        //   Validar: true,
        // });

        let lcLog = "";
        let llValidar = true;
        let llConsumo = 0;
        let llMedia = 0;
        let lnMedia_Ref = 15;
        let contador = loMediaConsumo.length;
        let indice = 0;
        let lnConsu_Ref = 0;
      try {
      
       
 
  
        // if (loMediaConsumo.length > 0) {
        //       for (let i = 0; i < loMediaConsumo.length; i++) {
        //           if (loMediaConsumo[i].Estado == 1) {
        //             lnConsu_Ref = lnValorRef > 0 ? lnValorRef : loMediaConsumo[i].ConsumoReferencia;
        //           //RESUELTO
        //             llConsumo = this.EvaluarExpresion(loMediaConsumo[i].Consumo_Net, "CON", Consumo, lnConsu_Ref);
        //             lnMedia_Ref = lnValorRef > 0 ? lnValorRef : loMediaConsumo[i].MediaReferencia;
        //             llMedia = this.EvaluarExpresion(loMediaConsumo[i].Media_Net, "MED", tcMedia, lnMedia_Ref);
        
        //               if (llConsumo && llMedia) {
        //                 llValidar = loMediaConsumo[i].Validar;
        //                 break;
        //               }
        //           }
        //       }
        // } else {
        //   lcLog = "Error, Sin Registros";
        //   console.error(lcLog);
        // }

        if (contador > 0) {
              while (contador > 0) {
                  if (loMediaConsumo[indice].Estado == 1) {
                      lnConsu_Ref = lnValorRef > 0 ? lnValorRef : loMediaConsumo[indice].ConsumoReferencia;
                      llConsumo = this.EvaluarExpresion(loMediaConsumo[indice].Consumo_Net, "CON", Consumo, lnConsu_Ref);
                      lnMedia_Ref = lnValorRef > 0 ? lnValorRef : loMediaConsumo[indice].MediaReferencia;
                      llMedia = this.EvaluarExpresion(loMediaConsumo[indice].Media_Net, "MED", tcMedia, lnMedia_Ref);

                      if (llConsumo && llMedia) {
                          llValidar = loMediaConsumo[indice].Validar;
                          break;
                      }
                  }
                  indice += 1;
                  contador -= 1;
              }
          } else {
              lcLog = "Error, Sin Registros";
          }


      } catch (error) {
        lcLog = "Error";
        console.error(lcLog, error);
      }
  
      if (llValidar == 1) {
        return  true;
      }else{
        return false; 
      }
    }
  
    //RESUELTO
    EvaluarExpresion(tcExpresion, tcToken, tnValor, tnValorReferencia) {
      let llValidar = true;
  
      if (tcExpresion.toUpperCase() == this.MenorIgualQue) {
        llValidar = tnValor <= tnValorReferencia;
      } else if (tcExpresion.toUpperCase() == this.MayorQue) {
        llValidar = tnValor > tnValorReferencia;
      }
      return llValidar;
    }

  async getMediaConsumo() {
      try {
        const db = await getDataBase();
        const tx = db.transaction('MEDIACONSUMO', 'readonly');
        const store = tx.objectStore('MEDIACONSUMO');
        // const Data = await store.get(Number(tnMediaConsumo));
        const laData = await store.getAll();
        await tx.done;
        return laData;
      } catch (error) {
        console.error('Error metodo getMediaConsumo  de dbindex:', error);
        return [];
      }
  }


  }
  